import { DAYSMART_CATEGORIES_TO_ENABLE_INTEGRATION } from './DaySmart.constants';

export function isDaySmartIntegrationAllowed(business) {
  const { category } = business;
  return DAYSMART_CATEGORIES_TO_ENABLE_INTEGRATION.includes(category);
}
